import { useQuery, useInfiniteQuery } from '@tanstack/react-query';
import { getToday } from 'utils/helpers';
import { PROPOSALS_URL } from 'utils/api';
import api from '../../../core/api';
import { normalizeProposals, normalizeProposalsFilters } from '../normalizer/normalizeProposals';

async function fetchProposalsCenter(ctx) {
  const [, value] = ctx.queryKey;

  console.log('value', value);

  const paramFilters = value && value.length > 0
    ? value
    : `?Filtros.listaDataContratacao=${getToday()}`;

  const { data } = await api.get(PROPOSALS_URL + paramFilters);
  const { propostas, filtro } = data;

  const proposals = propostas ? normalizeProposals(propostas) : [];
  const filters = filtro ? normalizeProposalsFilters(filtro) : [];

  console.log('propostas', propostas);
  return { proposals, filters };
}

function useProposalsCenter(value) {
  const { isLoading, data, refetch } = useQuery(['proposals center', value], fetchProposalsCenter);

  return {
    isLoading,
    refetch,
    filters: data?.filters,
    proposals: data?.proposals,
  };
}

export default useProposalsCenter;
